<mat-form-field class="chip-list hmt-form-field" appearance="outline" >
  <mat-label class="uppercase">{{label}}</mat-label>
  <mat-chip-grid #chipGrid aria-label="Item selection">
    <mat-chip-row
      *ngFor="let item of selectedItems"
      [removable]="removable"
      (removed)="remove(item)" 
      class="chip">
      {{item?.name}}
      <button matChipRemove *ngIf="removable" class="cancel">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      [placeholder]="placeholder"
      #selectedItemInput
      [formControl]="formControl"
      [matAutocomplete]="autoComplete"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [readonly]="disabled"
      >
  </mat-chip-grid>
  <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="selectItem($event.option.value)" [autoActiveFirstOption]="true" [panelWidth]="'auto'" [class.mat-autocomplete-panel-no-close]="true">
    <mat-option *ngFor="let item of filteredItems | async" [value]="item">
      {{item?.name}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
